import { render } from "./MBalanceDetails.vue?vue&type=template&id=5e56a722&scoped=true"
import script from "./MBalanceDetails.vue?vue&type=script&lang=js"
export * from "./MBalanceDetails.vue?vue&type=script&lang=js"

import "./MBalanceDetails.vue?vue&type=style&index=0&id=5e56a722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e56a722"]])

export default __exports__